/*
 * Copyright (c) University of Technology Sydney. All rights reserved.
 * See LICENSE file in the project root for full license information.
 *
 * Project Name: wpt-frontend.
 * Author: Tim Porritt
 * Created: 27/01/22
 */

import { useContext } from 'react';
import { AssignmentContext } from '@/components/contexts/AssignmentContext/AssignmentProvider';

export const useAssignment = () => {
    return useContext(AssignmentContext);
};
